module.exports = __webpack_public_path__ + "img/Malleolo_MED_DX.2cdc5f3f.png";